import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { toast } from 'react-hot-toast';
import type { Course } from '../../types/course';

export function useCourseList() {
  const [courses, setCourses] = useState<Course[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function loadCourses() {
      try {
        const { data, error } = await supabase
          .from('courses')
          .select(`
            *,
            course_marketplace_listings (
              price,
              sale_price,
              sale_ends_at
            )
          `)
          .eq('is_published', true)
          .order('created_at', { ascending: false });

        if (error) throw error;
        setCourses(data || []);
      } catch (err) {
        console.error('Error loading courses:', err);
        setError(err instanceof Error ? err : new Error('Failed to load courses'));
        toast.error('Failed to load courses');
      } finally {
        setIsLoading(false);
      }
    }

    loadCourses();
  }, []);

  return { courses, isLoading, error };
}